const imageoptimization = {
  qualityParameter: 'q',
  qualityValue: '90',
}

export default imageoptimization
